export function setSearchesLoading (state, loading = false) {
  state.searchesLoading = loading
}

export function setIpsLoading (state, loading = false) {
  state.ipsLoading = loading
}

export function setSearches (state, searches) {
  state.searches = searches.data
  state.searchesCurrentPage = searches.current_page
  state.searchesLastPage = searches.last_page
  state.searchesPerPage = searches.per_page
  state.searchesTotal = searches.total
}

export function setIpsOrders (state, { ips }) {
  state.searches.forEach((el, index) => {
    const elipindex = el.ips.findIndex((elip) => {
      return ips.findIndex(x => x._id == elip.ip) > -1
    })

    if(elipindex > -1) {
      state.searches[index].ips.forEach((elip, elindex) => {
        const ipsindex = ips.findIndex(x => x._id == elip.ip)
        if(ipsindex > -1) {
          state.searches[index].ips[elindex].comenzi = ips[ipsindex].comenzi
          return true
        }

        return false
      })
    }
  })
  /** state.searches[storeindex].ips = state.searches[storeindex].ips.map(el => {
    const ipsindex = ips.map(e => e._id).indexOf(el.ip)
    return ipsindex > -1 ? { ...el, comenzi: ips[ipsindex].comenzi } : { ...el, comenzi: 0 }
  })**/
}

export function setIndexPage (state, page = null) {
  state.indexPage = page
}

export function setSearch (state, search = '') {
  state.search = search
}

export function setDatefrom (state, datefrom = '') {
  state.datefrom = datefrom
}

export function setDateto (state, dateto = '') {
  state.dateto = dateto
}

export function setIPOrdersLoading (state, loading = false) {
  state.ipOrdersLoading = loading
}
